import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500 mt-1">为你精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/lifestyle"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}